/**
 * Партии, которые Mureka умеет дописывать к готовому треку (`track_type`
 * в /track/generate). Один справочник на все UI — десктопный ряд настроек,
 * мобильная шторка и подписи в кабинете, — чтобы названия не разъехались.
 *
 * Значения — РОВНО как их принимает API (регистр важен для читаемости логов;
 * бэкенд сверяет регистронезависимо). Пустая строка = инструментал целиком,
 * прежнее поведение «+ Инструментал».
 */
export interface TrackPart {
	/** Значение для API (пусто = весь инструментал). */
	value: string
	/** Что увидит юзер. Говорим о результате, а не о параметре. */
	label: string
}

export const TRACK_PARTS: TrackPart[] = [
	{ value: '', label: 'Вся музыка' },
	{ value: 'Drums', label: 'Ударные' },
	{ value: 'Bass', label: 'Бас' },
	{ value: 'Guitar', label: 'Гитара' },
	{ value: 'Keyboard', label: 'Клавишные' },
	{ value: 'Percussion', label: 'Перкуссия' },
	{ value: 'Strings', label: 'Струнные' },
	{ value: 'Synth', label: 'Синтезатор' },
	{ value: 'Brass', label: 'Духовые медные' },
	{ value: 'Woodwinds', label: 'Духовые деревянные' },
	{ value: 'FX', label: 'Звуковые эффекты' },
	{ value: 'Vocals', label: 'Вокал' },
]

/** Подпись выбранной партии. Неизвестное значение → как есть (не теряем). */
export function trackPartLabel(value: string | undefined | null): string {
	const v = (value || '').trim()
	if (!v) return TRACK_PARTS[0].label
	return TRACK_PARTS.find((p) => p.value.toLowerCase() === v.toLowerCase())?.label || v
}
